import * as React from 'react';

import { cn, Select, type SelectProps } from '@rematter/ui-web';

import { useTransportationTypesQuery } from '~/modules/transportation/hooks/queries/useTransportationTypesQuery';

export type TransportationTypeSelectProps = Omit<
  SelectProps<string>,
  'options' | 'selectedKey' | 'onSelectionChange' | 'isLoading' | 'className'
> & {
  value?: string;
  onChange?: (value: string | number | undefined) => void;
  className?: string;
};

export const TransportationTypeSelect = ({
  value,
  onChange,
  ...props
}: TransportationTypeSelectProps) => {
  const { data, isLoading } = useTransportationTypesQuery({
    limit: 50,
  });

  const options = React.useMemo(
    () => data?.transportationTypes ?? [],
    [data?.transportationTypes],
  );

  const selectOptions = React.useMemo(
    () => options.map((item) => ({ key: item.id, label: item.name })),
    [options],
  );

  return (
    <Select
      {...props}
      options={selectOptions}
      value={value}
      onChange={onChange}
      isLoading={isLoading}
      className={cn('@TransportationTypeSelect', props.className)}
    />
  );
};
